
// export const ROWS_PER_PAGE_EMERGENCY = "ROWS_PER_PAGE_EMERGENCY";
// export const ROWS_PER_PAGE_CAUTION = "ROWS_PER_PAGE_CAUTION";
// export const ROWS_PER_PAGE_DEVICE = "ROWS_PER_PAGE_DEVICE";
export const ROWS_PER_PAGE_EMERGENCY_HISTORIES = "ROWS_PER_PAGE_EMERGENCY_HISTORIES";


// export const updateRowsPerPageEmergency = param1 => {
//     return{
//       type: ROWS_PER_PAGE_EMERGENCY,
//       payload: param1
//     }
// }

// export const updateRowsPerPageCaution = param1 => {
//     return{
//       type: ROWS_PER_PAGE_CAUTION,
//       payload: param1
//     }
// }

// export const updateRowsPerPageDevice = param1 => {
//     return{
//       type: ROWS_PER_PAGE_DEVICE,
//       payload: param1
//     }
// }

export const updateRowsPerPageEmergencyHistories = param1 => {
  return{
    type: ROWS_PER_PAGE_EMERGENCY_HISTORIES,
    payload: param1
  }
}
